import { render } from "./MenuManageModal.vue?vue&type=template&id=bd977b9a&scoped=true"
import script from "./MenuManageModal.vue?vue&type=script&lang=js"
export * from "./MenuManageModal.vue?vue&type=script&lang=js"

import "./MenuManageModal.vue?vue&type=style&index=0&id=bd977b9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd977b9a"]])

export default __exports__